import React from 'react'
import { SectionContainer } from 'src/components/common/SharedComponents'
import {
  body,
  colors,
  heading,
  maxWidth,
  mediaQuery,
  spacing,
  typographyMixin,
} from 'src/constants/marketing-ds'

import styled from 'styled-components'

const pageTypes = {
  error: {
    title: '404: This page is out of bounds',
    subtitle: 'But don’t sweat it — the game’s still on.',
    text: (
      <>
        Let’s run it back → <a href={'https://fubo.tv/stream/tv'}>Return to Fubo</a>
        <br />
        Need help? → Head to <a href={'https://support.fubo.tv/'}>support.fubo.tv</a>
      </>
    ),
    itemsTitle: 'Streaming on Fubo:',
    items: [
      'Live NFL, NBA, MLB, NHL & more',
      '350+ live TV channels',
      'Unlimited Cloud DVR',
      'No cable required',
    ],
  },
}

const StatusTemplate = ({ type = null, title, subtitle, text }) => {
  return (
    <SectionContainer backgroundColor={colors.gradients.slate.medium}>
      <PageWrapper>
        <div className={'page-content' + (type === 'error' ? ' page-content-error' : '')}>
          {type === 'error' ? (
            <>
              <div>
                <img
                  src="https://assets-imgx.fubo.tv/marketing/lp/images/logos/Fubo_Primary_Logo_FC_RGB.png?w=140&ch=width&auto=format,compress"
                  alt="fubo"
                />
                <h1>{pageTypes.error.title}</h1>
                <h2>{pageTypes.error.subtitle}</h2>
                <h3>{pageTypes.error.itemsTitle}</h3>
                <ul>
                  {pageTypes.error.items.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>
              <div>
                <p>{pageTypes.error.text}</p>
              </div>
            </>
          ) : (
            <>
              <div>
                <img
                  src="https://assets-imgx.fubo.tv/marketing/lp/images/logos/Fubo_Primary_Logo_FC_RGB.png?w=140&ch=width&auto=format,compress"
                  alt="fubo"
                />
                <h1>{title}</h1>
                {subtitle && <h2>{subtitle}</h2>}
              </div>
              {text && (
                <div>
                  <p>{text}</p>
                </div>
              )}
            </>
          )}
        </div>
      </PageWrapper>
    </SectionContainer>
  )
}

export default StatusTemplate

const PageWrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: #fff;
  .page-content {
    max-width: 700px;
    padding: ${spacing.xxxxl} 0;
    display: flex;
    flex-direction: column;
    &.page-content-error {
      max-width: ${maxWidth.desktop};
    }
    img {
      max-width: 120px;
      margin-bottom: ${spacing.xl};
      ${mediaQuery.tablet} {
        max-width: 140px;
      }
    }
    h1 {
      ${typographyMixin(heading.xl)}
      margin-bottom: ${spacing.md};
      ${mediaQuery.tablet} {
        ${typographyMixin(heading.xxl)}
      }
    }
    h2 {
      ${typographyMixin(body.md)}
      margin-bottom: ${spacing.xl};

      ${mediaQuery.tablet} {
        ${typographyMixin(body.lg)}
        margin-bottom: ${spacing.xxl};
      }
    }
    h3 {
      ${typographyMixin(heading.sm)}
      margin-bottom: ${spacing.sm};
      ${mediaQuery.tablet} {
        ${typographyMixin(heading.md)}
      }
    }
    p {
      ${typographyMixin(body.sm)}
      a {
        text-decoration: underline;
      }
    }

    ul {
      margin-left: ${spacing.sm};
      margin-bottom: ${spacing.lg};
    }

    li {
      ${typographyMixin(body.sm)}
      list-style: disc;
      margin-bottom: ${spacing.xs};
      a {
        text-decoration: none;
      }
    }
  }
`
